import { utcToZonedTime } from 'date-fns-tz';

// Fallback when account has not chosen a timezone yet (matches platform default).
const PLATFORM_DEFAULT_TIMEZONE = 'UTC';

let activeTimeZone = PLATFORM_DEFAULT_TIMEZONE;

export const setAccountTimeZone = timeZone => {
  activeTimeZone = timeZone || PLATFORM_DEFAULT_TIMEZONE;
};

export const getAccountTimeZone = () =>
  activeTimeZone || PLATFORM_DEFAULT_TIMEZONE;

export const toAccountZonedTime = date => {
  const zone = getAccountTimeZone();
  if (!zone) return date;

  try {
    return utcToZonedTime(date, zone);
  } catch {
    return date;
  }
};
